const SEPARATORS = /[\s,;:،؛٫٬\u200B-\u200D\uFEFF]+/u;

const ANGLED = /[^,;،؛\r\n]*<([^<>]+)>/gu;

const EDGES = /^[\s"'`(<[{.]+|[\s"'`)>\]}.,]+$/gu;

const ADDRESS = /^[^\s@,;<>"']+@[^\s@,;<>"'.]+(?:\.[^\s@,;<>"'.]+)+$/u;

export function isEmail(value: string): boolean {
  return ADDRESS.test(value);
}

export type EmailScan = {
  accepted: string[];

  rejected: string[];
};

export function scanEmails(raw: string, existing: readonly string[] = []): EmailScan {
  const seen = new Set(existing.map((address) => address.toLowerCase()));
  const accepted: string[] = [];
  const rejected: string[] = [];

  for (const piece of raw.replaceAll(ANGLED, ",$1,").split(SEPARATORS)) {
    const trimmed = piece.replaceAll(EDGES, "");
    if (trimmed === "") continue;
    const address = trimmed.toLowerCase();
    if (!isEmail(address)) {
      rejected.push(trimmed);
      continue;
    }

    if (seen.has(address)) continue;
    seen.add(address);
    accepted.push(address);
  }

  return { accepted, rejected };
}

export function parseEmails(raw: string, existing: readonly string[] = []): string[] {
  return scanEmails(raw, existing).accepted;
}

export function isSeparatorKey(key: string): boolean {
  return key.length === 1 && SEPARATORS.test(key);
}

export function holdsSeparator(text: string): boolean {
  return SEPARATORS.test(text);
}
